import type { InjectionKey } from 'vue'
import type { ComponentInternalInstance } from 'vue'

export const MESSAGE_LIST_KEY = 'MESSAGE_LIST'
export const AGREEMENT_KEY = 'STATEMENT_AGREE'
export const MAX_STORAGE_SIZE = 1024 * 1024 * 5
//export const MAX_STORAGE_SIZE = 1024 * 50
export const SELECTOR_MODAL = Symbol() as InjectionKey<{
  mountChild: (inst: ComponentInternalInstance) => void
}>
